import { Navigate, useParams } from "react-router-dom";

/** Redirige l'ancienne URL /ventes/:id vers /factures/:id (compat favoris). */
export function LegacyVenteRedirect() {
  const { id } = useParams();
  return <Navigate to={`/factures/${id}`} replace />;
}
